import {
  JobRecord,
  JobState,
  JobStateKeys,
  JobType,
} from '@texas/api/endpoints/jobRecordsApi';
import { JobItem } from '@texas/components/jobs/JobItem';
import { compareEnum, ensureEnumKey } from '@texas/utils/helpers/enumHelpers';
import { Flex, Text } from '@chakra-ui/react';
import {
  blinkAnimation,
  fadeInBottomAnimation,
  fadeInLeftAnimation,
} from '@texas/resources/animations/animations';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

export function JobMessage({ job }: { job: JobRecord }) {
  if (compareEnum(JobType, job.type, JobType.AiPrompt)) {
    return <AiJobMessage job={job} />;
  }
  return <JobItem job={job} />;
}

function AiJobMessage({ job }: { job: JobRecord }) {
  const { t } = useTranslation();
  return (
    <Flex opacity={0.7} flexDir="column" scrollMarginTop={4}>
      <Text animation={fadeInLeftAnimation()}>
        {AiMessageTitle({ jobState: job.state, t })}
      </Text>
      <Text
        animation={
          compareEnum(JobState, job.state, JobState.Running)
            ? blinkAnimation()
            : fadeInBottomAnimation()
        }
        fontStyle="italic"
        fontSize="sm"
      >
        {job.latestMessage}
      </Text>
    </Flex>
  );
}

function AiMessageTitle({
  jobState,
  t,
}: {
  jobState: JobState;
  t: TFunction;
}): string {
  const type = ensureEnumKey(JobState, jobState) as unknown as JobStateKeys;

  return t(`ai.job.${type}`);
}
